<template>
  <AnalyticsCard
    title="Where bookings are lost"
    subtitle="Events people opened but could not book"
    :loading="loading"
    :empty="!loading && data.length === 0"
    empty-title="Nothing was turned away"
    empty-hint="Everyone who opened one of your calendars found a slot, and nobody's booking form was rejected."
    skeleton="list"
    :rows="4"
    :height="240"
  >
    <div class="divide-y divide-gray-50 dark:divide-gray-800/60">
      <div v-for="row in data" :key="row.id" class="px-5 py-3">
        <div class="flex items-center gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full flex-shrink-0" :style="{ backgroundColor: row.color }"></span>
          <span class="text-sm font-medium text-gray-800 dark:text-gray-100 truncate flex-1">{{ row.name }}</span>
          <span class="text-sm font-bold text-amber-600 dark:text-amber-400 tabular-nums flex-shrink-0">{{ row.no_slots }}</span>
        </div>

        <div v-if="row.opened > 0" class="mt-2 flex h-1.5 rounded-full overflow-hidden bg-emerald-100 dark:bg-emerald-900/30">
          <span class="h-full bg-amber-400 transition-[width] duration-500"
            :style="{ width: `${(row.no_slots / row.opened) * 100}%` }"></span>
        </div>

        <p class="mt-1.5 text-[11px] text-gray-400 dark:text-gray-500">
          <template v-if="row.opened > 0">
            {{ row.no_slots }} of {{ row.opened }} people who opened this calendar saw nothing bookable
          </template>
          <template v-else>{{ row.no_slots }} people saw nothing bookable</template>
          <template v-if="row.failed > 0">
            &middot; <span class="text-red-500 dark:text-red-400">{{ row.failed }} had the form rejected</span>
          </template>
        </p>
      </div>
    </div>
  </AnalyticsCard>
</template>

<script setup>
import AnalyticsCard from '../shared/AnalyticsCard.vue'

defineProps({
  data:    { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})
</script>
